import { render, staticRenderFns } from "./WysiwygEditorDialog.vue?vue&type=template&id=554292ad&"
import script from "./WysiwygEditorDialog.vue?vue&type=script&lang=js&"
export * from "./WysiwygEditorDialog.vue?vue&type=script&lang=js&"
import style0 from "./WysiwygEditorDialog.vue?vue&type=style&index=0&id=554292ad&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports